// src/components/GoogleTagManager.js
import { useEffect } from "react";

const GoogleTagManager = ({ trackingId = "AW-17498230685" }) => {
  useEffect(() => {
    // Load the Google Tag script
    const script1 = document.createElement("script");
    script1.async = true;
    script1.src = `https://www.googletagmanager.com/gtag/js?id=${trackingId}`;
    document.head.appendChild(script1);

    // Initialize gtag
    const script2 = document.createElement("script");
    script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${trackingId}');
    `;
    document.head.appendChild(script2);
  }, [trackingId]);

    return null; // This component doesn’t render anything visible
};

export default GoogleTagManager;
